<template>
  <div>
    <button type="button" class="btn pull-right mb-3" @click="extract"
      style="margin-bottom: 1%;font-weight:bold;background-color:#4cbb17; color:white">
      <i class="fa fa-file-excel-o" aria-hidden="true"></i>Extrair dados
    </button>


    <base-crud crudName="Logs de usuarios " :table="userTable" :columns="columns" :options="options"
      :endPoint="endPoint" :enableAdd="false" :enableEdit="false" :enableDelete="false" :enableView="true"
      :extra="extra" 
      ref="userTable"></base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
import QrcodeVue from "qrcode.vue";
import swal from "sweetalert";
import Loading from 'vue-loading-overlay';
import env from '@/config/env';

export default {
  data: function () {
    return {
      isLoading: false,
      fullPage: true,
      usersDeleted: false,
      userTable: "userTable",
      users: [],
      pages: [],
      url: "",
      columns: ["id", 'name', 'date', 'type_access'],
      tableData: ["id", 'name', 'date', 'type_access'],
      options: {
        filterable: ["id"],
        filterByColumn: true,
        sortable: ["id", "name", "email"],
        templates: {
          team_id: (h, row, index) => {
            return row.team ? row.team.name : '';
          },
          branch_id: (h, row, index) => {
            return row.branch ? row.branch.name : '';
          },
          role_id: (h, row, index) => {
            return row.role ? row.role.name : '';
          },
          term_accepted: (h, row, index) => {
            return row.term_accepted == 1 ? 'Aceito' : 'Ainda não aceito';
          },
          deleted_at: (h, row, index) => {
            return row.deleted_at == null ? 'Ativo' : 'Desativado';
          },
          term_accepted_at: (h, row, index) => {
            return row.term_accepted_at ?
              row.term_accepted_at.substr(8, 2) + '/' +
              row.term_accepted_at.substr(5, 2) + '/' +
              row.term_accepted_at.substr(0, 4)
              : '';
          }
        },
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          name: "Nome",
          date: "Data",
          type_access: "Tipo acesso",

        },
        requestFunction: function (data) {
          let requestData = {};

          // Obtem a query inicial
          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [];


          requestData.params.filter = {};


          if (query.trim() === "") {
            query = "";
          }


          if (query.trim() === "") {
            requestData.params.per_page = this.options.perPage;
          } else {

            requestData.params.per_page = 1000;
            this.perPage = false;
            this.perPageValues = false;
          }

          // Retorna a requisição com a query completa
          return this.$http
            .get(this.url + '?' + query, requestData)
            .catch(
              function (e) {
                this.dispatch("error", e);
              }.bind(this)
            );
        }

      },
      extra: [

      ],
      endPoint: "logsuseraccesses/"
    };
  },
  methods: {

    query: function (query) {
      let columns = {
        id: 'id',
        name: 'name',
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });

      filters += "usersDeleted=" + this.usersDeleted;

      return filters;
    },
    extract() {
      const url = `${env.baseURL}downloadLogUser`; // Constrói a URL com base no env
      this.$http
        .get(url, {
          responseType: 'blob',
          headers: {
            'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          }
        })
        .then(response => {
          const blobURL = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = blobURL;
          link.setAttribute('download', 'user_logs.xlsx'); // Define o nome do arquivo
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch(error => {
          console.error('Erro ao processar o download:', error);
        });
    }
  },
  components: {
    BaseCrud,
    QrcodeVue,
    Loading
  }
};
</script>

<style>
.switch {
  position: relative;
  display: inline-block;
  width: 34px;
  height: 20px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 10px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked+.slider {
  background-color: #4cbb17;
}

input:checked+.slider:before {
  transform: translateX(14px);
}

.VuePagination {
  text-align: center;
}

.btn.btn-warning2 {
  background-color: rgb(7, 101, 124) !important;
  color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/UserLogs/Crud.vue